/* "Choose Method" drawer: product card Add to cart / Choose options open the product's quick view
   (templates/product.quick-view.json) in a right-side drawer instead of ajax-adding or navigating.
   Shell: layout/theme.liquid (#fasc-cm). Cards opt in with data-fasc-choose-method="<product url>"
   (snippets/product-item.liquid). The product JS is Warehouse's own ProductSection, instantiated
   through the theme's section:load hook since theme.js does not expose it. */
(function () {
  'use strict';

  var SECTION_ID = 'fasc-cm';
  var drawer, body, opener, requestId = 0;

  function isOpen() { return drawer && drawer.getAttribute('aria-hidden') === 'false'; }

  function unloadSection() {
    if (!body.firstChild) return;
    document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: SECTION_ID } }));
    body.innerHTML = '';
    // fasc-fulfillment.js moves each selector's store drawer to <body>; drop the ones this drawer brought in.
    document.querySelectorAll('[data-fasc-drawer][data-fasc-cm-owned]').forEach(function (el) { el.remove(); });
  }

  function open(url, trigger) {
    var id = ++requestId;
    opener = trigger || null;
    unloadSection();
    drawer.classList.add('is-loading');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fasc-cm-open');

    var productUrl = new URL(url, window.location.origin);
    productUrl.searchParams.set('view', 'quick-view');

    fetch(productUrl.href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (id !== requestId || !isOpen()) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-section-type="product"]');
        if (!section) throw new Error('no product section');
        section.setAttribute('data-section-id', SECTION_ID);
        section.querySelectorAll('[data-fasc-drawer]').forEach(function (el) { el.setAttribute('data-fasc-cm-owned', ''); });
        body.appendChild(document.importNode(section, true));
        // theme.js's SectionContainer builds the ProductSection from event.target's first [data-section-id].
        body.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: SECTION_ID } }));
        drawer.classList.remove('is-loading');
        drawer.querySelector('.fasc-cm__panel').focus();
      })
      .catch(function () { window.location.href = url; });
  }

  function close() {
    if (!isOpen()) return;
    requestId++;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-loading');
    document.documentElement.classList.remove('fasc-cm-open');
    if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  function openMiniCart() {
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    var miniCart = document.getElementById('mini-cart');
    if (toggle && miniCart && miniCart.getAttribute('aria-hidden') !== 'false') toggle.click();
  }

  function init() {
    drawer = document.getElementById('fasc-cm');
    if (!drawer) return;
    body = drawer.querySelector('[data-fasc-cm-body]');

    // Capture phase so Warehouse's delegated card handlers (ajax add, quick view modal, link) never see the click.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-fasc-choose-method]');
      if (!trigger || trigger.disabled || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      e.stopPropagation();
      open(trigger.getAttribute('data-fasc-choose-method'), trigger);
    }, true);

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-fasc-cm-close]')) { e.preventDefault(); close(); }
    });

    // Capture so the store picker (which closes on the same Escape) stays the only thing that closes.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen() && !document.body.classList.contains('fasc-drawer-open')) close();
    }, true);

    // cart_type is "message", so Warehouse only flashes an alert. Swap to: close drawer, open the mini-cart
    // once the Cart section has re-rendered (it ends with theme:loading:end).
    drawer.addEventListener('product:added', function () {
      close();
      document.addEventListener('theme:loading:end', function onEnd() {
        document.removeEventListener('theme:loading:end', onEnd);
        openMiniCart();
      });
    });

    drawer.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      var img = drawer.querySelector('[data-fasc-cm-image]');
      if (!img || !v || !v.featured_image) return;
      img.removeAttribute('srcset');
      img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
